module.exports = "<div class=\"container d-flex align-items-center justify-content-center m-auto\">\n  <i class=\"svg-container mr-2\" inlineSVG=\"/assets/images/icon.svg\"></i>\n  <div>\n    <h1>\n      404. Страница не найдена:(\n    </h1>\n    <p>По всем вопросам вы можете связаться с нами через контакты на сайте:</p>\n    <a href=\"https://ветераны.рф\">ветераны.рф</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/not-found-page/not-found-page.component.html
// module id = ./src/app/core/not-found-page/not-found-page.component.html
// module chunks = main